import { render, staticRenderFns } from "./SlideProduct.vue?vue&type=template&id=2107dd8a&lang=html"
import script from "./SlideProduct.vue?vue&type=script&lang=js"
export * from "./SlideProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports